
import {Vue} from "vue-class-component";
import {Prop} from "vue-property-decorator";

export default class ErrorMessage extends Vue {
  @Prop({type: String, default: null}) errorMessage: null | string = null;
}
